<template>
  <!-- Reusable "How the Risk Score is calculated" modal.
       level = user | organisation | department | group.
       For aggregate levels it also explains the median roll-up. -->
  <div class="modal fade" id="vcroFormulaModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">How the Risk Score is calculated</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body">
          <p class="fs-13 mb15">A user's Risk Score is the <strong>average of their active risk factors</strong> — each scored 0&ndash;100 (higher = more risk).</p>
          <h6 class="bold mb5 fs-13">FACTORS</h6>
          <ul class="fs-13 mt-0 pl-3">
            <li class="mb5">Behavior = (Clicked / Opened) &times; 100</li>
            <li class="mb5">Training = (Assigned &minus; Evaluated) / Assigned &times; 100<br><span style="opacity:.75;font-style:italic;">Note: only mandatory trainings count toward the score.</span></li>
            <li class="mb5">Amplifier = highest amplifier set by the company for the user or their groups</li>
          </ul>
          <div class="fs-13 mb15">Each factor is a 0&ndash;100 score and is <strong>capped at 100</strong> — Behavior can work out above 100% when there are more clicks than opens, so it's clamped.</div>
          <div class="fs-13 mb15">A user's Risk Score = average of the factors that apply (a factor with no data is skipped, not counted as zero).</div>
          <template v-if="isAggregate">
            <h6 class="bold mb5 fs-13">{{ levelWord.toUpperCase() }} SCORE</h6>
            <div class="fs-13 mb15">The {{ levelWord }} Risk Score is the <strong>median</strong> of its members' individual User Risk Scores, and each factor (Behavior / Training / Amplifier) is likewise the median of members' individual factor values: sort everyone's values and take the middle one, so a few outliers don't skew it the way a plain average would.</div>
          </template>
          <h6 class="bold mb5 fs-13">RISK LEVELS</h6>
          <div class="fs-13">Low 0&ndash;24 &middot; Medium 25&ndash;49 &middot; High 50&ndash;74 &middot; Critical 75&ndash;100</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VcroFormulaInfo',
  props: {
    // user | organisation | department | group
    level: { type: String, default: 'organisation' }
  },
  computed: {
    isAggregate() {
      return ['organisation', 'department', 'group'].indexOf(this.level) !== -1;
    },
    levelWord() {
      return this.level;
    }
  }
};
</script>



// WEBPACK FOOTER //
// VcroFormulaInfo.vue?437d6b30